import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  SharedModule,
  FormInputComponent,
  BooleanCustomFieldConfig,
} from "@bb-vendure/admin-ui/core";

@Component({
  template: `
  <div [ngStyle]="{'display': 'flex', 'justify-content': 'space-between'}">
  <!-- <label> Use this product as a free gift </label>
  <input
      type="checkbox"
      clrToggle
      name="enabled"
      [formControl]="formControl"
    />
  </div> -->
  `,
  standalone: true,
  imports: [SharedModule],
})
export default class FreeGiftToggleComponent
  implements FormInputComponent<BooleanCustomFieldConfig>
{
  readonly: boolean;
  config: BooleanCustomFieldConfig;
  formControl: FormControl;
}
